import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';
export const ALERT_PRODUCT_REQUEST_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.product_request_success',
    translate: true,
  },
};
